import type { EDimensionKey } from '~/presentation/reports/common/type';

import { DIMENSION_UI } from '~/presentation/reports/common/ReportFilter/constants/dimension';

export function getDimensionSettingUIs(data: EDimensionKey[]) {
  return data.map((key) => DIMENSION_UI[key]);
}
